<div class="cart-header">
  <h3>Shopping Cart</h3>
</div>

<ng-container *ngIf="cartService.checkout?.cart; else noCart">
  <div class="cart-body">
    <div class="line-items">
      <div class="cart-bottom">
        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item" (click)="editorContent = product">
              <a (click)="lastPage()" class="circle-con sm-btn">
                <i class="fas fa-long-arrow-alt-left"></i>
              </a>
            </div>
          </div>

          <div class="level-right">
            <div class="level-item" (click)="editorContent = product">
              <a (click)="shareModal = true" class="circle-con sm-btn">
                <i class="fas fa-external-link-alt"></i> Share Cart
              </a>
            </div>
            <div class="level-item">
              <a
              class="circle-con sm-btn bg-accent-1 white dark-hover"
              (click)="requestQuote()"
              >Request Special Pricing
            </a>
          </div>
        </div>
      </div>
    </div>

    <div
        *ngFor="
          let item of cartService.checkout?.cart?.line_items?.physical_items.concat(
            cartService.checkout?.cart?.line_items?.custom_items
          )
        "
        class="line-item"
      >
        <img [src]="item.image_url" />
        <a [href]="item.url" class="name">{{ item.name }}</a>
        <met-quantity-selector
          [qty]="item.quantity"
          (quantity)="cartService.updateItem(item, $event)"
        ></met-quantity-selector>
        <span>{{ item.list_price * item.quantity | currency }}</span>
        <i (click)="cartService.removeItem(item.id, cid)" class="fas fa-times"></i>
      </div>

      <met-product-selector
        (selection)="addSelectedItem($event)"
      ></met-product-selector>
    </div>
    <div class="checkout-bar">
      <div class="field has-addons">
        <div class="control i">
          <input
            [disabled]="loaded"
            class="input"
            [(ngModel)]="loadingCartId"
            name="loadedcartid"
            type="text"
            placeholder="Load Cart by ID"
          />
        </div>
        <div class="control">
          <!-- add -->
          <a
            class="button primary-bg p1em"
            *ngIf="!loaded"
            (click)="cartService.loadCart(loadingCartId)"
          >
            <i class="fas fa-long-arrow-alt-right"></i>
          </a>
          <!-- remove -->
          <a
            class="button primary-bg is-info"
            *ngIf="loaded"
            (click)="loadCartIdRm()"
          >
            <i class="fas fa-times"></i>
          </a>
        </div>
      </div>

      <met-totals [checkout]="cartService.checkout"></met-totals>

      <a class="checkout button" (click)="gotocheckout(); loading($event, 6000)"
        >Checkout</a
      >

      <div class="level">
        <div class="level-left">
          <p class="b estimateModalTrigger">
            <a class="bold_link" (click)="estimateModal = true"
              >Get Shipping Quote</a
            >
          </p>
        </div>
        <div class="level-right">
          <ul class="inline paymentcons">
            <li
              *ngFor="let item of payments | async | keyvalue"
              [class.hide]="!item.value.visible"
              title="{{ item.value.title }}"
              class="footcon-li"
            >
              <i class="footcon {{ item.value.icon }}"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <br />
  <pre>{{ cartService.checkout | json }}</pre>
</ng-container>

<ng-template #noCart>
  ur cart is empty
  <met-product-selector
    (selection)="addSelectedItem($event)"
  ></met-product-selector>
</ng-template>
